/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Grid, FormControl, FormControlLabel, Switch, Tooltip } from '@mui/material';
/**
 * Custom toggle switch implementation
 * @param {String} label - label of the switch component
 * @param {Function} onChange - trigger the function when switch change
 * @param {String} title - title for the tooltip
 * @param {Boolean} checked - selected status of the toggle switch
 * @param {String} sx - custom style for entire component
 * @param {String} placement - element placement of the component
 * @param {String} size - size of toggle switch
 * @param {String} labelPlacement - placement of toggle label
 * @returns
 */
const CustomToggleSwitch = ({
  label,
  onChange,
  title = '',
  checked = false,
  sx = {},
  placement = 'top',
  disabled = false,
  size = 'medium',
  labelPlacement = 'end',
  secondaryLabel = null,
  id = '',
  paddingBottom = 0,
  className = ''
}) => (
  <div className={className}>
  <FormControl sx={{ paddingBottom }}> 
    <Tooltip title={title} placement={placement}>
      <Grid container direction="row" alignContent="center">
        <Grid item>
          <FormControlLabel
            id={id}
            control={
              <Switch
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                size={size}
                id={`${id}`}
              />
            }
            label={!secondaryLabel && label}
            labelPlacement={labelPlacement}
            sx={{
              width: 'fit-content',
              maxWidth: '100%',
              height: 5,
              ...(!secondaryLabel && {
                gap: 1,
                '& .MuiFormControlLabel-label': {
                  minWidth: 0,
                  overflow: 'hidden',
                  whiteSpace: 'normal',
                },
              }),
              ...sx,
            }}
          />
        </Grid>
        {secondaryLabel && (
          <Grid
            item
            xs={9}
            cc={6}
            md={9}
            marginLeft={-4}
            sx={{ color: disabled ? 'gray' : 'inherit' }}
          >
            {label}
            <span style={{ fontSize: 11.5, color: 'gray' }}> {secondaryLabel}</span>
          </Grid>
        )}
      </Grid>
    </Tooltip>
  </FormControl>
  </div>
);
//
export default CustomToggleSwitch;
